import { Anchor, Table, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';

type Props = {
  areAllItemsOnThisPageSelected: boolean;
  areAllItemsAcrossPagesSelected: boolean;
  totalObjects: number;
  pageLimit: number;
  itemsLength: number;
  onToggleAcrossPages: () => void;
};

// The "N rows selected — select all M across pages" banner, shown above the table
// body when the whole current page is selected and more rows exist than fit on a page.
export function TableSelectionBanner({
  areAllItemsOnThisPageSelected,
  areAllItemsAcrossPagesSelected,
  totalObjects,
  pageLimit,
  itemsLength,
  onToggleAcrossPages,
}: Props) {
  const { t } = useTranslation();

  if (!areAllItemsOnThisPageSelected || totalObjects <= pageLimit) return null;

  // When the across-pages selection is active the two counts swap: the message
  // counts every row (totalObjects) and the inline action offers the page (itemsLength).
  const selectedCount = areAllItemsAcrossPagesSelected ? totalObjects : itemsLength;
  const toggleCount = areAllItemsAcrossPagesSelected ? itemsLength : totalObjects;

  return (
    <Table.Tr>
      <Table.Td colSpan={100} bg="gray.1" ta="center">
        <Text size="sm" span>
          {t(selectedCount === 1 ? i18nKeys.SELECTED_ELEMENT : i18nKeys.SELECTED_ELEMENTS, {
            count: selectedCount,
          })}{' '}
          <Anchor
            component="button"
            type="button"
            fz="sm"
            c="purple.6"
            onClick={onToggleAcrossPages}
          >
            {t(toggleCount === 1 ? i18nKeys.SELECT_ELEMENT : i18nKeys.SELECT_ELEMENTS, {
              count: toggleCount,
            })}
          </Anchor>
        </Text>
      </Table.Td>
    </Table.Tr>
  );
}
